<div class="login-container">
    <div class="login-box">
      <h2>Sign In</h2>

      <form (ngSubmit)="login()" #loginForm="ngForm">
        <div class="form-group">
          <label for="email">Email</label>
          <input
            type="email"
            id="email"
            [(ngModel)]="email"
            name="email"
            required
          />
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <input
            type="password"
            id="password"
            [(ngModel)]="password"
            name="password"
            required
          />
        </div>

        <button class="btn-brand" type="submit" [disabled]="loginForm.invalid">Login</button>
        <p class="create-account-link">
            Don't have an account?
            <a routerLink="/register">Create one</a>
          </p>
      </form>

      <div class="divider">or</div>

      <button class="google-login" (click)="loginWithGoogle()">
        <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" />
        Continue with Google
      </button>
    </div>
    <div id="recaptcha-container"></div>
  </div>
